import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 16px;
	max-height: 60vh;
	overflow: hidden;
	overflow-y: auto;
	font-size: 16px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	&::-webkit-scrollbar {
		width: 6px;
		background-color: rgba(32, 30, 27, 0.5);
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #c2bdb2;
		border-radius: 3px;

		&:hover {
			background-color: rgba(242, 247, 64, 0.9);
		}
	}

	&::-webkit-scrollbar-track {
		background-color: rgba(64, 62, 57, 0.3);
		border-radius: 3px;
	}

	scrollbar-width: thin;
	scrollbar-color: $control-dark rgba(64, 62, 57, 0.3);

	@media (max-width: 992px) {
		max-height: unset;
	}
`;

export const Offer = styled.div`
	font-size: 14px;
	font-weight: 400;
	font-style: normal;
	color: ${({ theme }) => theme.colors.text.body};
`;
